export interface InterstitialAdConfig {
  container: HTMLDivElement;
  onFinish: () => void;
}

export class InterstitialAd {
  protected messageListener: any;

  constructor(protected config: InterstitialAdConfig) {
    const IFRAME_SRC = document.querySelector('script[src*="video-ads.js"]')?.getAttribute('src')?.split('/').slice(0, -1).join('/');
    this.messageListener = window.addEventListener('message', (message: any) => {
      if (message.data.type === 'h5-finish') {
        this.destroy();
        this.config.onFinish();
      }
    });
    this.config.container.innerHTML = `
      <div style="padding-bottom: 56.25%; width: 100%; position: relative;">
        <iframe src="${IFRAME_SRC}/index.html" allow="autoplay" style="width: 100%; height: 100%; border: 0; position: absolute; top: 0; left: 0"></iframe>
      </div>
      `;
  }

  async show(): Promise<void> {

  }

  async destroy(): Promise<void> {

  }
}
